<template>
  <main>
    <h1>Page not found</h1>
  </main>
</template>

<script lang="ts" setup>
/* ... */
</script>

<style lang="scss" scoped>
h1 {
  text-align: center;
}
</style>
